import { useState, useEffect } from "react";
import styles from "../assets/styles/DivorceInsurance.module.css";
import LDU from "../assets/images/DivorceInsurance/ldu.png";
import LOn from "../assets/images/DivorceInsurance/lon.png";
import LOff from "../assets/images/DivorceInsurance/loff.png";

export default function AskStarLoading(context) {
  const [imageData, setImageData] = useState("");
  const [imageDataOn, setImageDataOn] = useState("");
  const [imageDataOff, setImageDataOff] = useState("");
  const [bulbOn, setbulbOn] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const img = new Image();
    const imgOn = new Image();
    const imgOff = new Image();

    imgOff.onload = () => {
      imgOn.onload = () => {
        img.onload = () => {
          const viewportWidth = window.innerWidth;
          const maxWidth = 500;
          const imageWidth = Math.min(viewportWidth, maxWidth);
          const imageHeight = (imageWidth / img.width) * img.height;

          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);

          ctx.font = "80px NotoSansKR-Bold";
          ctx.fillStyle = "#fe7312";

          drawTextBox(
            ctx,
            context.nickname,
            img.width / 2,
            910 - 187,
            canvas.width,
            1.4,
            true
          );

          let base64Image = canvas.toDataURL("image/png");
          // setImageData(base64Image);

          // save imageOn
          ctx.drawImage(imgOn, 360, 363 - 187, 239, 305);
          base64Image = canvas.toDataURL("image/png");
          setImageDataOn(base64Image);

          // redraw and save imageOff
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, img.width, img.height);
          ctx.font = "80px NotoSansKR-Bold";
          ctx.fillStyle = "#fe7312";

          drawTextBox(
            ctx,
            context.nickname,
            img.width / 2,
            910 - 187,
            canvas.width,
            1.4,
            true
          );
          ctx.drawImage(imgOff, 395, 399 - 187, 170, 269);
          base64Image = canvas.toDataURL("image/png");
          setImageDataOff(base64Image);
          setReady(true);
          setbulbOn(!bulbOn);
        };
        img.src = LDU;
      };
      imgOn.src = LOn;
    };
    imgOff.src = LOff;
  }, []);

  useEffect(() => {
    if (bulbOn) {
      setImageData(imageDataOn);
    } else {
      setImageData(imageDataOff);
    }

    setTimeout(() => {
      setbulbOn(!bulbOn);
    }, 1000);
  }, [bulbOn]);

  const drawTextBox = (
    ctx,
    text,
    x,
    y,
    fieldWidth,
    spacing,
    center = false
  ) => {
    // Build lines by iterating over each character.
    let lines = [];
    let line = "";
    const fontSize = parseFloat(ctx.font);

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const tempLine = line + char;
      const tempWidth = ctx.measureText(tempLine).width;

      if (tempWidth < fieldWidth && char !== "\n") {
        line = tempLine;
      } else {
        lines.push(line);
        line = char === "\n" ? "" : char;
      }
    }
    lines.push(line);

    // Center mode: center align horizontally and vertically around (x, y)
    if (center) {
      ctx.textAlign = "center";
      // Calculate total text height based on spacing.
      const totalHeight = lines.length * fontSize * spacing;
      // Adjust y so that the block of text is vertically centered.
      let startY = y - totalHeight / 2 + fontSize;
      for (let j = 0; j < lines.length; j++) {
        ctx.fillText(lines[j], x, startY + j * fontSize * spacing);
      }
    }
    // Left-align mode: x,y is the start point.
    else {
      ctx.textAlign = "start";
      let currentY = y;
      for (let j = 0; j < lines.length; j++) {
        ctx.fillText(lines[j], x, currentY);
        currentY += fontSize * spacing;
      }
    }
  };

  return (
    <div className="letterContainer">
      {ready ? (
        <img src={imageData} alt="ldu" className={styles.letterCanvas} />
      ) : null}
    </div>
  );
}
